{
    "overview": {
        "sectionName": "Overview",
        "section_worth": 0,
        "rules": [
            {
                "field": "industry",
                "check": "none"
            },
            {
                "field": "industrySubType",
                "check": "none"
            },
            {
                "field": "company_ceo",
                "check": "none"
            },
            {
                "field": "year_founded",
                "check": "none"
            },
            {
                "field": "last_full_fiscal_year_reported",
                "check": "none"
            }
        ]
    },
    "revenue_performance": {
        "sectionName": "Revenue Performance",
        "section_worth": 25,
        "rules": [
            {
                "field": "revenue_latest",
                "check": "none"
            },
            {
                "field": "organic_cagr_N_years",
                "check": "range",
                "dataPick": "biggest_key_with_value",
                "range": [-0.01, 0.1]
            },
            {
                "field": "projected_organic_cagr_N_years",
                "check": "range",
                "dataPick": "biggest_key_with_value",
                "range": [-0.01, 0.1]
            },
            {
                "field": "projected_organic_cagr_N_years_minus_tam_growth",
                "check": "range",
                "range": [-0.05, 0.05]
            },
            {
                "field": "gross_retention",
                "check": "range",
                "range": [0, 0.98]
            },
            {
                "field": "net_retention",
                "check": "range",
                "range": [0, 120]
            },
            {
                "field": "recurring_revenue_summary",
                "check": "boolean"
            }
        ]
    },

    "ebitda_performance": {
        "sectionName": "Margins & Profitability",
        "section_worth": 25,
        "rules": [
            {
                "field": "extended_selected_ebitda",
                "check": "none"
            },
            {
                "field": "adj_ebitda",
                "check": "greater_than",
                "threshold": 20,
                "range": [10, 30]
            },
            {
                "field": "adj_ebitda_margin",
                "check": "range",
                "range": [0, 0.25]
            },
            {
                "field": "gross_profit_margin",
                "check": "range",
                "range": [0.4, 0.8]
            },
            {
                "field": "adj_ebitda_margin_trend",
                "check": "range",
                "range": [-0.1, 0.1]
            },
            {
                "field": "ebitda_magnatitude_adjustment",
                "check": "range",
                "inverse_score": true,
                "range": [0.05, 0.5]
            }
        ]
    },

    "market_size_and_performance": {
        "sectionName": "Market Size and Performance",
        "section_worth": 25,
        "rules": [
            {
                "field": "total_addressable_market",
                "check": "range",
                "range": [0, 5]
            },
            {
                "field": "historical_market_growth",
                "check": "range",
                "range": [0, 10]
            },
            {
                "field": "projected_market_growth",
                "check": "range",
                "range": [0, 10]
            }
        ]
    },

    "fcf_profile": {
        "sectionName": "FCF Profile",
        "section_worth": 25,
        "rules": [
            {
                "field": "nwc_as_percent_of_revenue",
                "check": "range",
                "range": [-0.1, 0.3],
                "inverse_score": true
            },
            {
                "field": "free_cash_flow_conversion",
                "check": "range",
                "range": [0.25, 0.95]
            },
            {
                "field": "total_capex_by_rev",
                "check": "range",
                "range": [0.01, 0.3],
                "inverse_score": true
            }
        ]
    },

    "concentration": {
        "sectionName": "Concentration",
        "section_worth": 25,
        "rules": []
    },

    "other": {
        "sectionName": "Other",
        "section_worth": 25,
        "rules": []
    }
}
